<style scoped>
  .el-collapse-item__header {
      padding-left: 15px;
  }
  .el-upload--picture-card {
    float: left;
    margin-right: 10px;
} 
  .circle-closesty {
      position: relative;
    top: -35px;
    margin-left: 112px;
    font-size: 20px;
    cursor: pointer;
  }
  .v-modal {
    z-index: 100 !important;
  }
  .ipt-sty {
    width: 67% !important;
}
.el-col-5{
  width: 30%;
}    
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="10">
        <el-col :span="8">
          <div class="search-area-div">人员：</div>
          <el-input v-model="page.staffName" class="ipt-sty" placeholder="请输入人员"></el-input>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div w115">推广费发放主体：</div>
          <el-select v-model="page.levyCompanyGuid" placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in tenantListDz" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">签约公司：</div>
          <el-select v-model="page.insuredCompanyGuid" placeholder="请选择" class="ipt-sty" filterable>
            <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15 t-right">
        <el-col :span="24">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class=" back-color-fff p16 mt15">
      <div class="summary-sty mt15">人数:<b class="fontC-4fa1a4"> {{tableData.peopleNum}} </b>推广费发放主体:<b class="fontC-4fa1a4 mlf10"> {{tableData.levyCompanyNum}} 家</b> 签约公司:<b class="fontC-4fa1a4 mlf10">
          {{tableData.insuredCompanyNum}} 家 </b>推广费总额(元):<b class="fontC-4fa1a4 mlf10"> {{tableData.performanceTotalAmount | numDigit | numFmt}}</b></div>
      <el-table :data="tableData.performanceReportDetailVOS" border style="width: 100%;" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="人员" header-align="center" align="center" width="100" fixed="left"></el-table-column>
        <el-table-column prop="organisationNames" label="组织" header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.organisationNames | roleNames}}</template>
        </el-table-column>
        <el-table-column prop="positionNames" label="岗位" header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.positionNames | roleNames}}</template>
        </el-table-column>
        <el-table-column prop="performanceAmount" label="推广费(元)" header-align="center" align="right" width="150">
          <template slot-scope="scope">{{ scope.row.performanceAmount | numDigit | numFmt}}</template>
        </el-table-column>
        <el-table-column prop="mobileNo" label="手机号" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="idCode" label="身份证号" header-align="center" align="center" width="200"></el-table-column>
        <el-table-column prop="levyCompanyName" label="推广费发放主体(代征公司)" header-align="center" align="center" width="200">
        </el-table-column>
        <el-table-column prop="insuredCompanyName" label="签约公司" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="bankAccount" label="账户" header-align="center" align="center" width="200"></el-table-column>
        <el-table-column prop="bank" label="开户行" header-align="center" align="center" width="200">
        </el-table-column>
        <el-table-column prop="picNum" label="上报照片数(推广费月份)" width="160" header-align="center" align="right" fixed="right"></el-table-column>
        <el-table-column prop="orderNum" label="上报订单数(推广费月份)" width="160" header-align="center" align="right" fixed="right"></el-table-column>
        <el-table-column prop="visitNum" label="上报拜访次数(推广费月份)" width="160" header-align="center" align="right" fixed="right"></el-table-column>
        <el-table-column prop="orderAmount" label="上报业绩(推广费月份)" width="150" header-align="center" align="right" fixed="right">
          <template slot-scope="scope">{{ scope.row.orderAmount | numDigit | numFmt}}</template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="确定发放" :visible.sync="dialogVisible1" width="30%">
      <div class="t-left">
        <img width="25" class="fl" src="../../assets/images/remind1.png">
        <p>实际的推广费资金发放请在对应的代征平台上完成，此处只记录发放状态<br>此处的发放凭证指链享向代征平台的支付凭证</p>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" :label-position="right" class="demo-ruleForm">

        <el-form-item label="发放时间:" prop="sendTime" class="t-left">
          <el-date-picker v-model="ruleForm.sendTime" type="date" placeholder="选择发放时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发放凭证:">
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl1" alt="">
          </el-dialog>
          <el-upload action="#" name="image" class="fl" list-type="picture-card" :headers="token" :file-list="fileList" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :http-request="uploadImage">
            <div slot="image" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible1 = false">取 消</el-button>
        <el-button size="medium" type="info" @click="payPerformance">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script> 
import { route } from '@/api/apiRoute';
import store from '@/store'
export default {
  data() {
    return {
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        'Authorization': store.state.token
      },
      active: 0,
      page: {
        pageIndex: 1,
        pageSize: 1000,
        totalPage: 0,
        totalRows: 0,
        levyCompanyGuid: '',
        insuredCompanyGuid: '',
        staffName: '',
        performanceGuid: '',
        performanceReportGuid: '',
        isUploadReceipt: ''
      },
      dialogVisible1: false,
      fileList: [],
      dialogImageUrl1: '',
      dialogVisible: false,
      disabled: false,
      sendVoucherAttach: [],
      ruleForm: {
        sendTime: '',
      },
      rules: {
        sendTime: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
      },
      tenantList: [],
      tenantListDz: [],
      tableData: '',
      sendTime: '',
      right: 'right',
      tableLoading: false,
      height: window.innerHeight - 340,

    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getTenant();
    this.getTenantDz();
    // this.getCurrentManageStaff();
  },
  methods: {
    getTenant() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, { 'enterpriseCates': ['9903', '9904'], 'pageSize': 100 }).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTenantDz() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, { 'enterpriseCate': '9904' }).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantListDz = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    uploadImage(file) {
      let self = this;
      console.log(file.file);
      self.fileList = [];
      self.sendVoucherAttach = [];
      let formData = new FormData();
      formData.append('image', file.file)
      self.api.postImage(self.url, formData).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // self.ruleForm.platformLogo = res.data.data;
          let item = {
            name: '回执单',
            url: res.data.data
          }
          let item1 = {
            fileName: '回执单',
            path: res.data.data
          }
          self.sendVoucherAttach.push(item1);
          self.fileList.push(item);
          // self.ruleForm.icon = res.data.data;
          self.$message.success('上传成功');
        } else {
          elf.$message.error('上传失败,请重新上传!')
        }

      }).catch(() => {
        self.$message('上传失败,请重新上传')
      })
    },
    handleRemove(file) {
      let self = this;
      self.ruleForm.icon = '';
      self.iconSh = false;
      self.fileList = [];
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl1 = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },




    selectInit(row, index) {
      if (row.picNum > 1) {
        return true  //不可勾选
      } else {
        return false  //可勾选
      }
    },
    top() {
      let self = this;
      self.active = 0;
    },
    next() {
      let self = this;
      self.active = 1;
      self.customerCount = 0;
      self.franchiseeCount = 0;
      let flg = false;
      self.userMarketingList.forEach(function (m) {
        m.attachY = [];
        m.originalAttachY = [];
        m.attach.forEach(function (n) {
          if (n.checked) {
            self.customerCount++;
            flg = true;
            let imgs = {
              fileName: n.fileName,
              path: n.path
            }
            m.attachY.push(imgs);
          } else {
            let imgsN = {
              fileName: n.fileName,
              path: n.path
            }
            m.originalAttachY.push(imgsN);
          }
        })
        if (m.attachY.length > 0 && m.attachY.length == m.attach.length) {
          self.$message.error("请不要勾选此次拜访所有图片！");
          self.active = 0;
          return
        }
        if (m.attachY.length == 0) {
          self.$message.error("请勾选此次拜访图片！");
          self.active = 0;
          return
        }
        if (flg) {
          self.franchiseeCount++;
        }
      })
    },
    empty() {
      let self = this;
      self.timeList = '';
      self.timeListS = '';
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        userName: '',
        startTime: '',
        endTime: '',
        province: ''
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.page.performanceGuid = self.$router.history.current.query.guid;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/performance/data/get-performance-report-summary-detail`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    report() {
      let self = this;
      self.page.performanceGuid = self.$router.history.current.query.guid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/performance/data/export-performance-report`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success("导出成功");
          // self.tableData = res.data.data.records;
          // self.page.totalPage = res.data.data.totalPages;
          // self.page.totalRows = res.data.data.totalRows; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    payPerformance() {
      let self = this;
      if (!self.ruleForm.sendTime) {
        self.$message.error("请选择发放时间！");
        return
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/performance/data/pay-performance`, { 'performanceGuid': self.$router.history.current.query.guid, 'sendTime': self.ruleForm.sendTime, 'sendVoucherAttach': self.sendVoucherAttach }).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success("发放成功");
          this.$router.push({ path: "/performancePayment" })
          // self.tableData = res.data.data.records;
          // self.page.totalPage = res.data.data.totalPages;
          // self.page.totalRows = res.data.data.totalRows; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
     height: 40px; 
     line-height: 40px; 
}
.el-range-editor.el-input__inner { 
     padding: 0px; 
}
/deep/ .el-checkbox__label {
    display: none;
}
.attach-sty {
    width: 170px;
    float: left; 
    margin-top: 15px;
    text-align: center;
}
.checkbox-img-sty {
    border: 1px solid #DCDFE6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
}
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
</style>